import { useTranslation } from '@cx-modules/i18n-provider';

export const DefaultLoadingFallback = () => {
  const { t } = useTranslation('label');
  return <div data-testid="default-loading-fallback">{t('CX_ERROR_LOADING_TEXT', { ns: 'label' })}</div>;
};
